<template>
  <div class="breadcrumb" :class="{ 'locale-zh-CN': isZhLocale }">
    <img src="~@/assets/img/gongxuzhongxin/location.png" alt="" class="location-icon" />
    <template v-for="(item, index) in breadcrumbList" >
      <span :class="['bread-item', { active: index === breadcrumbList.length - 1, clickable: hasPath(item.path) }]"
        @click="handleClick(item)">
        {{ item.label }}
      </span>
      <span v-if="index < breadcrumbList.length - 1" class="separator">
        /
      </span>
    </template>
  </div>
</template>

<script>
import { getText } from '@/utils/i18nText'

export default {
  name: 'Breadcrumb',
  props: {
    // 面包屑数据数组，支持最多4级
    // 格式: [{ label: '首页', path: '/index' }, { label: '供需中心', path: '/supply-demand' }, ...]
    items: {
      type: Array,
      default: () => [],
      validator: (value) => {
        // 最多支持4级
        if (value.length > 4) {
          console.warn(getText('breadcrumb.maxLevelWarning', 'Breadcrumb: 最多支持4级导航'))
          return false
        }
        // 验证每项必须有label
        return value.every(item => item.label)
      }
    }
  },
  computed: {
    breadcrumbList() {
      // 限制最多4级
      return this.items.slice(0, 4)
    }
  },
  methods: {
    hasPath(path) {
      return typeof path === 'string' && path.trim().length > 0
    },
    handleClick(item) {
      // 如果有path且不是当前激活项，则触发点击事件
      if (this.hasPath(item.path)) {
        this.$emit('click', item)
        // 默认行为：使用vue-router跳转
        if (this.$router && item.path !== this.$route.path) {
          this.$router.push(item.path)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  margin-top: 19px;
  margin-left: 113px;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 6px;

  .location-icon {
    width: 16px;
    height: 20px;
    flex-shrink: 0;
  }

  .bread-item {
    font-family: Source Han Sans CN;
    font-size: 13px;
    color: #444444;
    transition: color 0.3s;
    white-space: nowrap;

    &.clickable {
      cursor: pointer;

      &:hover:not(.active) {
        color: #A0903C;
      }
    }

    &.active {
      color: #A0903C;
    }
  }

  .separator {
    color: #666666;
    margin: 0 3px;
    flex-shrink: 0;
  }
}

.breadcrumb.locale-zh-CN .bread-item {
  font-size: 18px;
}
</style>
